export function setCookie() {
    return (dispatch) => {
        dispatch({
            type: 'CLOSE_WARNING',
            payload: {
                cookie_warning: true
            }
        });
    }
}


// WEBPACK FOOTER //
// frontend/src/actions/actionCookie.js